module.exports = __webpack_public_path__ + "static/media/thumbs_down.ceed10d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbs_down.svg
// module id = 623
// module chunks = 0